const Vue = require('vue')

Vue.component('form-photo', require('components/std/Photo.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/photo.js